import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { FormattedMessage } from 'react-intl';
import { ReactDataTable, MoneyCell, DefaultButton, StatusCell, BasicModal, DateCell } from 'common/components';

import { withTheme } from 'common/styling/theme';
import { RejectWithdrawalForm } from '../../payments/_components';

import { staticStyles, getDynamicStyles } from './style';

const UserWithdrawRequest = ({ totalAmount, requests, canReject, match, theme }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const groupId = match.params.id;

  const [isOpen, setIsOpen] = useState(false);
  const [activeRequestId, setActiveRequestId] = useState(null);
  const [depositAddresses, setDepositAddresses] = useState([]);
  const [currentRequestAddress, setCurrentRequestAddress] = useState('');
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const handleRejectWithdrawal = id => {
    setActiveRequestId(id);
    toggleModal();
  };

  const handleCheckAddress = async (id, address) => {
    try {
      // 保存当前请求的地址以便匹配比较
      setCurrentRequestAddress(address);
      // 调用API获取存款地址
      const response = await axios.get(`/backoffice/withdraw/get_deposit_address/${id}`);
      setDepositAddresses(response.data.addresses);
      setIsAddressModalOpen(true);
    } catch (error) {
      // console.error('Error fetching deposit addresses:', error);
    }
  };

  const closeAddressModal = () => {
    setIsAddressModalOpen(false);
    setDepositAddresses([]);
    setCurrentRequestAddress('');
  };

  /* eslint-disable */
  const columns = [
    {
      accessor: 'id',
      Header: 'justId',
      Cell: ({
        row: {
          original: { id },
        },
      }) => <span>{id}</span>,
      isPreviewCell: true,
    },
    {
      accessor: 'account',
      Header: 'justAccount',
      Cell: ({
        row: {
          original: { accountLogin },
        },
      }) => <span>{accountLogin}</span>,
      isPreviewCell: true,
    },
    {
      accessor: 'commission',
      Header: 'justCommission',
      Cell: ({
        row: {
          original: { id, commission },
        },
      }) => <MoneyCell tooltipId={`UserWithdrawRequest-justCommission-${id}`} inTable value={commission} />,
      isPreviewCell: true,
    },
    {
      accessor: 'paymentSystem',
      Header: 'boPaymentSystem',
      Cell: ({
        row: {
          original: { paymentMethodTitle },
        },
      }) => <span>{paymentMethodTitle}</span>,
    },
    {
      accessor: 'created',
      Header: 'justCreated',
      Cell: ({
        row: {
          original: { created },
        },
      }) => <DateCell value={created} />,
    },
    {
      accessor: 'amount',
      Header: 'justAmount',
      Cell: ({
        row: {
          original: { id, amount },
        },
      }) => <MoneyCell tooltipId={`UserWithdrawRequest-justAmount-${id}`} inTable value={amount} />,
      isPreviewCell: true,
    },
    {
      accessor: 'address',
      Header: 'boWithdrawalsAddress',
      Cell: ({
        row: {
          original: { address },
        },
      }) => <span>{address || '-'}</span>,
    },
    {
      accessor: 'comment',
      Header: 'justComment',
      Cell: ({
        row: {
          original: { comment },
        },
      }) => <span>{comment || '-'}</span>,
    },
    {
      accessor: 'check',
      Header: 'boDepositsAddress',
      Cell: ({
        row: {
          original: { id, address },
        },
      }) =>
        address ? (
          <DefaultButton textId="justCheck" type="button" onClick={() => handleCheckAddress(id, address)} />
        ) : (
          <span>-</span>
        ),
      Footer: (
        <div className="TotalCell">
          {' '}
          <FormattedMessage id="justTotalAmount">{txt => <span className="subtext">{txt}</span>}</FormattedMessage>{' '}
          <MoneyCell value={totalAmount} />{' '}
        </div>
      ),
    },
    {
      accessor: 'status',
      Header: () => null,
      Cell: ({
        row: {
          original: { id, status },
        },
      }) => {
        return status === 'waiting_approval' && canReject ? (
          <DefaultButton
            textId="justReject"
            type="button"
            butColor="error"
            onClick={() => handleRejectWithdrawal(id)}
          />
        ) : (
          <StatusCell statusCode={status} />
        );
      },
    },
  ];
  /* eslint-enable */
  const onRowClick = (state, rowInfo) => {
    setActiveRequestId(rowInfo.original.id);
  };

  // 定义地址弹窗的表格列
  const addressColumns = [
    {
      accessor: 'address',
      Header: 'boAddress',
      Cell: ({ value }) => <span>{value}</span>,
    },
    {
      accessor: 'match',
      Header: 'boMatch',
      Cell: ({ value }) => (
        <span style={{ color: value ? 'green' : 'red', fontSize: '18px' }}>{value ? '✓' : '✕'}</span>
      ),
    },
  ];

  // 处理地址数据，添加匹配标志
  const addressData = depositAddresses.map(address => ({
    address,
    match: address === currentRequestAddress,
  }));

  return (
    <div className="UserWithdrawRequest">
      <FormattedMessage id="justUsersWithdrawRequests">
        {txt => <div className="UserWithdrawRequest__title">{txt}</div>}
      </FormattedMessage>

      <ReactDataTable columns={columns} data={requests} onRowClick={onRowClick} isResponsive />

      <BasicModal isOpen={isOpen} captionId="justRejectWithdrawal" onRequestClose={toggleModal}>
        <RejectWithdrawalForm toggleModal={toggleModal} groupId={groupId} requestId={activeRequestId} />
      </BasicModal>

      <BasicModal
        isOpen={isAddressModalOpen}
        captionId="boDepositsAddress"
        onRequestClose={closeAddressModal}
        modalClassName="deposit-address-modal">
        <div style={{ width: '100%', maxWidth: '600px', overflowX: 'hidden' }}>
          <ReactDataTable
            columns={addressColumns}
            data={addressData}
            isResponsive
            noHeader={false}
            withoutSort
            noResponsive
          />
        </div>
      </BasicModal>

      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
      <style jsx global>{`
        .deposit-address-modal .modal-content {
          max-width: 600px !important;
          width: 90% !important;
          max-height: none !important;
          height: auto !important;
        }

        /* 确保弹窗内容不会导致水平滚动 */
        .deposit-address-modal .BasicModal__content {
          overflow-x: hidden !important;
        }

        /* 为地址弹窗表格设置特定样式 */
        .deposit-address-modal .ReactDataTable {
          /* 重置表格布局 */
          display: table;
          width: 100%;
        }

        .deposit-address-modal .ReactDataTable__thead-row,
        .deposit-address-modal .ReactDataTable__tbody-row {
          /* 确保行只显示两列 */
          grid-template-columns: 1fr auto !important;
        }

        /* 调整地址弹窗表格的列样式 */
        .deposit-address-modal .ReactDataTable__thead-cell,
        .deposit-address-modal .ReactDataTable__tbody-cell {
          padding: 8px 16px;
        }

        /* 为两列设置更合理的宽度 */
        .deposit-address-modal .ReactDataTable__thead-row > th:nth-child(1),
        .deposit-address-modal .ReactDataTable__tbody-row > td:nth-child(1) {
          min-width: 200px;
          text-align: center;
        }

        .deposit-address-modal .ReactDataTable__thead-row > th:nth-child(2),
        .deposit-address-modal .ReactDataTable__tbody-row > td:nth-child(2) {
          min-width: 100px;
          text-align: center;
        }

        .deposit-address-modal .ReactDataTable__tbody-row > td:nth-child(2) span {
          margin: 0 auto;
        }

        .deposit-address-modal .ReactDataTable__wrapper .ReactDataTable .ReactDataTable__thead-row {
          text-transform: unset !important;
        }
      `}</style>
    </div>
  );
};

UserWithdrawRequest.propTypes = {
  totalAmount: PropTypes.object.isRequired,
  requests: PropTypes.array.isRequired,
  match: PropTypes.object.isRequired,
  canReject: PropTypes.bool.isRequired,
  theme: PropTypes.object,
};

UserWithdrawRequest.defaultProps = {
  theme: {},
};

export default compose(withTheme(), withRouter)(UserWithdrawRequest);
